import React, { useState } from "react"
import { say } from "../../../helpers/speech"
import { Switch } from "../../ui/Switch"
import Card from "./Card"

const getFileNameWithoutExtension = (filePath) =>
  filePath
    .split("/")
    .pop()
    .split(".")[0]
    .replaceAll("-", " ")
    .replaceAll("_", " ")

export default function Grid({
  cardslist,
  visibleCards,
  setVisibleCards,
  finishedCards,
  checkCards,
}) {
  const [upperCase, setUpperCase] = useState(false)

  const handleClick = () => {
    setUpperCase(!upperCase)
  }

  return (
    <div
      className="container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      <div className="row justify-content-md-center m5-1 mb-3">
        <div className="uppercase-switch">
          <Switch
            status={upperCase}
            setStatus={setUpperCase}
            onClick={handleClick}
          />
        </div>
      </div>
      <div className="wrapper">
        {cardslist.map((item, index) => (
          <Card
            key={index}
            type={item.type}
            className={` ${
              visibleCards.includes(index) ? "grid-card-show" : ""
            } ${
              finishedCards.includes(index)
                ? "grid-card-show grid-card-finished"
                : ""
            }`}
            onClick={() => {
              if (!finishedCards.includes(index)) {
                if (item.type === "txt") say(item.contenido, false)
                else {
                  const name = getFileNameWithoutExtension(item.contenido)
                  say(name, false)
                }
                switch (visibleCards.length) {
                  case 0:
                    setVisibleCards([index])
                    break
                  case 1:
                    if (visibleCards[0] !== index) {
                      setVisibleCards(visibleCards.concat(index))
                      checkCards(visibleCards[0], index)
                    }
                    break
                  case 2:
                    setVisibleCards([index])
                    break
                  default:
                    setVisibleCards([])
                }
              }
            }}
            content={item.contenido}
            upperCase={upperCase}
          />
        ))}
      </div>
    </div>
  )
}

Grid.defaultProps = {
  cards: [],
}
